export const localApiTokenStorageKey = 'weather2.localApiToken';

export function getLocalApiMode() {
  if (!import.meta.env.DEV) return 'auth';
  return import.meta.env.VITE_LOCAL_API_MODE || 'mock';
}

export function shouldBypassHostedAuth() {
  return import.meta.env.DEV && ['mock', 'token'].includes(getLocalApiMode());
}

export function isLocalMockApiMode() {
  return import.meta.env.DEV && getLocalApiMode() === 'mock';
}

export function isLocalTokenApiMode() {
  return import.meta.env.DEV && getLocalApiMode() === 'token';
}

export function readLocalApiToken() {
  if (!import.meta.env.DEV || typeof window === 'undefined') return '';

  const tokenFromUrl = new URLSearchParams(window.location.search).get('token');
  if (tokenFromUrl) {
    window.localStorage.setItem(localApiTokenStorageKey, tokenFromUrl);
    window.history.replaceState({}, document.title, window.location.pathname);
    return tokenFromUrl;
  }

  return window.localStorage.getItem(localApiTokenStorageKey) || '';
}
